import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import type { ClientBillingContact as BillingContactData } from 'types/biztech';

import type {
  BillingContactField,
  BillingContactValidationErrors,
  ClientBillingContact,
} from '@avalara/types/billingContact';

export const defaultBillingContactInfo = {
  Address1: null,
  Address2: null,
  City: null,
  Country: null,
  Fax: null,
  FirstName: null,
  LastName: null,
  MobilePhone: null,
  PersonalEmail: null,
  PostalCode: null,
  State: null,
  WorkEmail: null,
  WorkPhone: null,
};
export const defaultValidationErrors: BillingContactValidationErrors = {
  Address1: null,
  Address2: null,
  City: null,
  Country: null,
  Fax: null,
  FirstName: null,
  LastName: null,
  MobilePhone: null,
  PersonalEmail: null,
  PostalCode: null,
  State: null,
  WorkEmail: null,
  WorkPhone: null,
};

const initialState: ClientBillingContact = {
  billingContactInfo: { ...defaultBillingContactInfo },
  billingContactEditForm: { ...defaultBillingContactInfo },
  editFormToggle: false,
  showValidationErrors: false,
  validationErrors: { ...defaultValidationErrors },
};

const store = createSlice({
  name: 'billingContact',
  initialState,
  reducers: {
    receiveBillingContact(state, action) {
      state.billingContactInfo = { ...defaultBillingContactInfo, ...action.payload };
      state.billingContactEditForm = { ...defaultBillingContactInfo, ...action.payload };
      state.showValidationErrors = false;
      state.editFormToggle = false;
    },
    updateBillingContactEditForm(state, action: PayloadAction<{ field: BillingContactField; data: string | null }>) {
      const { field, data } = action.payload;
      state.billingContactEditForm[field] = data;
    },
    setBillingContactValidatedAddress(state, action: PayloadAction<{ data: Partial<BillingContactData> }>) {
      state.billingContactEditForm = { ...state.billingContactEditForm, ...action.payload.data };
    },
    resetBillingContactEditForm(state) {
      state.billingContactEditForm = state.billingContactInfo;
      state.showValidationErrors = false;
      state.editFormToggle = false;
      state.validationErrors = { ...defaultValidationErrors };
    },
    receiveBillingContactErrors(state, action) {
      state.validationErrors = action.payload;
    },
    showBillingContactValidationErrors(state) {
      state.showValidationErrors = true;
    },
  },
});

export const {
  receiveBillingContact,
  updateBillingContactEditForm,
  resetBillingContactEditForm,
  receiveBillingContactErrors,
  showBillingContactValidationErrors,
  setBillingContactValidatedAddress,
} = store.actions;
export default store;
